module.exports = __webpack_public_path__ + "static/media/Hero-Tabletop.d0643f43.jpg";